export const DANHSACHDANHMUC_SET_LIST_DATA = 'DANHSACHDANHMUC_SET_LIST_DATA';
export const DANHSACHDANHMUC_SET_LIST_META = 'DANHSACHDANHMUC_SET_LIST_META';
export const DANHSACHDANHMUC_TITLE = 'Danh Sách Danh Mục';